const sortArrByNumericKey = (arr, key, descending) => {
  arr.sort((a, b) => parseInt(b[key], 10) - parseInt(a[key], 10));

  if (descending) arr.reverse();

  return arr;
};

export default sortArrByNumericKey;
